import React from 'react'

class OutlineLabel extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			hovered: false
		}
	}

	handleMouseEnter = () => {
		this.setState({ hovered: true });
	}

	handleMouseOut = () => {
		this.setState({ hovered: false });
	}

	render() {

		const hover = {
			cursor: "pointer",
			background: "whitesmoke"
		}

		let style = {
			...this.props.style,
			display: "inline",
			border: "solid 1px",
			borderColor: this.props.color,
			color: this.props.color,
			paddingTop: "2px",
			paddingBottom: "2px",
			paddingLeft: "5px",
			paddingRight: "5px",
			borderRadius: "3px",
			cursor: "default"
		}

		if (this.props.onClick && this.state.hovered)
			style = { ...style, ...hover }

		return <React.Fragment>
			<div
				onMouseEnter={this.handleMouseEnter}
				onMouseOut={this.handleMouseOut}
				onClick={this.props.onClick}
				style={style}>
				{this.props.text}
			</div>
		</React.Fragment >
	}
}

OutlineLabel.defaultProps = {
	color: "blue"
}

export default OutlineLabel;


// WEBPACK FOOTER //
// ./src/areas/shared/components/outlineLabel/OutlineLabel.js